import RevenuePage from '../components/analytics/revenue/RevenuePage';

const RevenueAnalyticsPage = () => <RevenuePage />;

export default RevenueAnalyticsPage;
